/* Lazy-mount career backdrop SVG and pause animations when header is off-screen */
(function () {
    const header = document.querySelector('.gh-header.has-brand-hero');
    if (!header) return;

    const bg = header.querySelector('.gh-header-tech-bg');
    const tpl = document.getElementById('gh-header-backdrop-tpl');
    if (!bg || !tpl) return;

    let mounted = false;

    function mountBackdrop() {
        if (mounted) return;
        mounted = true;
        bg.appendChild(tpl.content.cloneNode(true));
        tpl.remove();
    }

    function setActive(active) {
        header.classList.toggle('is-active', active);
    }

    if (!('IntersectionObserver' in window)) {
        mountBackdrop();
        setActive(true);
        return;
    }

    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                mountBackdrop();
                setActive(true);
            } else if (mounted) {
                setActive(false);
            }
        });
    }, {
        rootMargin: '100px 0px',
        threshold: 0.01
    });

    observer.observe(header);
})();
